import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { useState } from 'react';
import { get_form_url } from './formUrl';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== 'website_alt')
            .map(([key, val]) => [key, val.toString()])
        ).toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后再试';
        setFormError(msg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    }
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '羞羞动漫网站',
    url: 'https://www.xiuxiudongman.com/',
    description: '专注于国产精品动漫内容的在线观看平台，提供蜜桃动漫、精品动漫推荐与动漫美女角色等内容。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@xiuxiudongman.com',
      availableLanguage: ['Chinese'],
    },
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 羞羞动漫网站',
    description: '了解羞羞动漫网站的品牌故事、口碑评价与联系方式。51动漫国产精品入口，精品动漫推荐平台。',
    url: 'https://www.xiuxiudongman.com/about',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

            <div className="mt-6">
              <h1 className="font-heading text-3xl md:text-4xl text-foreground-900 text-center mb-2">
                关于羞羞动漫
              </h1>
              <p className="text-sm text-foreground-500 text-center mb-8">51动漫国产精品入口 · 精品动漫推荐平台</p>
            </div>

            <section className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mb-10 md:mb-14">
              <div>
                <div className="bg-white rounded-lg border border-background-200/70 p-6 h-full">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                      <i className="ri-building-2-line text-primary-500"></i>
                    </div>
                    <h2 className="text-lg font-heading text-foreground-900">品牌故事</h2>
                  </div>
                  <div className="space-y-3 text-sm text-foreground-700 leading-relaxed">
                    <p>
                      羞羞动漫网站创立于2020年，是国内领先的<strong>动漫在线观看平台</strong>。我们致力于为广大动漫爱好者提供优质的<strong>国产精品动漫</strong>内容，涵盖<strong>蜜桃动漫</strong>、恋爱甜宠、奇幻冒险、热血战斗等多种类型。
                    </p>
                    <p>
                      作为<strong>51动漫国产精品入口</strong>的核心推荐平台，羞羞动漫网站汇聚了众多<strong>精品动漫推荐</strong>资源，包括丰富的<strong>动漫美女角色</strong>作品。我们每天更新最新动漫内容，确保用户能够第一时间观看到心仪的动漫。
                    </p>
                    <p>
                      我们的使命是打造中国最好的免费动漫平台，让每一个动漫爱好者都能在这里找到自己喜欢的作品。无论是<strong>蜜桃动漫在线观看</strong>，还是寻找<strong>动漫美女爆羞羞动漫</strong>资源，羞羞动漫都是您的最佳选择。
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-lg border border-background-200/70 p-6 h-full">
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                      <i className="ri-star-line text-accent-500"></i>
                    </div>
                    <h2 className="text-lg font-heading text-foreground-900">平台优势</h2>
                  </div>
                  <ul className="space-y-3">
                    {[
                      { icon: 'ri-checkbox-circle-line', text: '海量动漫资源，涵盖国产精品与蜜桃动漫等热门分类' },
                      { icon: 'ri-checkbox-circle-line', text: '高清画质播放，流畅观看体验' },
                      { icon: 'ri-checkbox-circle-line', text: '每日同步更新，最新动漫第一时间上线' },
                      { icon: 'ri-checkbox-circle-line', text: '完全免费观看，无需注册无需付费' },
                      { icon: 'ri-checkbox-circle-line', text: '精选动漫美女角色，精美画风呈现' },
                      { icon: 'ri-checkbox-circle-line', text: '51动漫国产精品入口直达推荐' },
                    ].map((item, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <i className={`${item.icon} text-primary-500 mt-0.5 shrink-0`}></i>
                        <span className="text-sm text-foreground-700">{item.text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </section>

            <section className="mb-10 md:mb-14">
              <div className="text-center mb-6">
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">用户口碑</h2>
                <p className="text-sm text-foreground-500">来自动漫爱好者的真实评价</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-5">
                {[
                  {
                    name: '动漫小迷妹',
                    rating: 5,
                    comment: '羞羞动漫网站真的太棒了！蜜桃动漫专区全部高清免费，国产精品动漫资源超多，每天都有更新，已经成为我的每日必看网站了！',
                    date: '2026-07-28',
                  },
                  {
                    name: '二次元少年',
                    rating: 5,
                    comment: '作为51动漫国产精品入口的老用户，羞羞动漫的推荐质量一直很高。动漫美女角色的画风非常精美，恋爱甜宠类的动漫也超好看！',
                    date: '2026-07-25',
                  },
                  {
                    name: '樱花飘落',
                    rating: 4,
                    comment: '朋友推荐的精品动漫推荐网站，资源确实很丰富。蜜桃动漫的分类很清晰，找动漫很方便。希望以后能增加更多国产原创动漫内容。',
                    date: '2026-07-20',
                  },
                  {
                    name: '追番达人',
                    rating: 5,
                    comment: '全国产精品动漫最全的平台！斗破苍穹、仙王的日常生活这些热门作品更新特别及时。羞羞动漫在线观看体验流畅，强烈推荐！',
                    date: '2026-07-18',
                  },
                  {
                    name: '蜜桃控',
                    rating: 5,
                    comment: '蜜桃动漫是我最喜欢的分类，画风甜美剧情温馨。羞羞动漫网站的推荐算法也很准，总能找到我喜欢的类型。必须五星好评！',
                    date: '2026-07-15',
                  },
                  {
                    name: '动漫老司机',
                    rating: 5,
                    comment: '用了很多动漫软件和网站，羞羞动漫是最良心的。免费无广告（广告很少），更新快，资源全。51动漫国产精品入口实至名归！',
                    date: '2026-07-10',
                  },
                ].map((review, i) => (
                  <div key={i} className="bg-white rounded-lg border border-background-200/70 p-4 md:p-5">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                        <i className="ri-user-line text-primary-500 text-sm"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900 whitespace-nowrap">{review.name}</p>
                        <p className="text-xs text-foreground-400 whitespace-nowrap">{review.date}</p>
                      </div>
                    </div>
                    <div className="flex gap-0.5 mb-2">
                      {Array.from({ length: review.rating }).map((_, j) => (
                        <div key={j} className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-star-fill text-accent-500 text-xs"></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{review.comment}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-10">
              <div className="bg-white rounded-lg border border-background-200/70 p-6">
                <div className="text-center mb-6">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-100">
                    <i className="ri-mail-send-line text-xl text-primary-500"></i>
                  </div>
                  <h2 className="font-heading text-2xl text-foreground-900 mb-1">联系我们</h2>
                  <p className="text-sm text-foreground-500">有任何问题或建议？欢迎给我们留言</p>
                </div>

                {formStatus === 'success' && (
                  <div className="max-w-lg mx-auto mb-4 p-4 bg-primary-50 border border-primary-200 rounded-lg text-center">
                    <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                      <i className="ri-check-line text-primary-500 text-lg"></i>
                    </div>
                    <p className="text-sm text-primary-700">感谢您的留言！我们会尽快回复您。</p>
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="max-w-lg mx-auto mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-center">
                    <p className="text-sm text-red-600">{formError}</p>
                  </div>
                )}

                <form
                  data-readdy-form=""
                  action={get_form_url()}
                  method="POST"
                  onSubmit={handleSubmit}
                  className="max-w-lg mx-auto space-y-4"
                >
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-foreground-800 mb-1">姓名</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-3 py-2 border border-background-300 rounded-lg text-sm bg-white focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-foreground-800 mb-1">邮箱</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-3 py-2 border border-background-300 rounded-lg text-sm bg-white focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-foreground-800 mb-1">留言内容</label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      rows={4}
                      maxLength={500}
                      className="w-full px-3 py-2 border border-background-300 rounded-lg text-sm bg-white focus:outline-none focus:border-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言（最多500字）"
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
                  </div>

                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />

                  <button
                    type="submit"
                    className="w-full py-2.5 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-send-plane-line mr-1.5"></i>发送留言
                  </button>
                </form>
              </div>
            </section>

            <section className="mb-10">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-5">
                <div className="bg-white rounded-lg border border-background-200/70 p-5 text-center">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-50">
                    <i className="ri-mail-line text-lg text-primary-500"></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">邮箱</h3>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">contact@xiuxiudongman.com</p>
                </div>
                <div className="bg-white rounded-lg border border-background-200/70 p-5 text-center">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-50">
                    <i className="ri-customer-service-2-line text-lg text-accent-500"></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">在线客服</h3>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">工作日 9:00-18:00</p>
                </div>
                <div className="bg-white rounded-lg border border-background-200/70 p-5 text-center">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-full bg-secondary-50">
                    <i className="ri-global-line text-lg text-secondary-500"></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">网址</h3>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">www.xiuxiudongman.com</p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}